const facts = `Mercury & Venus are the only 2 planets in our solar system that have no moons.
"If a star passes too close to a black hole, it can be torn apart."
The hottest planet in our solar system is Venus.
Our solar system is 4.57 billion years old.
"Enceladus, one of Saturn’s smaller moons, reflects 90% of the Sun’s light."
"The highest mountain discovered is the Olympus Mons, which is located on Mars."
The Whirlpool Galaxy (M51) was the first celestial object identified as being spiral.
A light-year is the distance covered by light in a single year.
"The Milky Way galaxy is 105,700 light-years wide."
"The Sun weighs about 330,000 times more than Earth."
Footprints left on the Moon won’t disappear as there is no wind.
"Because of lower gravity, a person who weighs 220 lbs on Earth would weigh 84 lbs on Mars."
There are 79 known moons orbiting Jupiter.
The Martian day is 24 hours 39 minutes and 35 seconds long.
NASA’s Crater Observation and Sensing Satellite (LCROSS) found evidence of water on the Earth’s Moon.
The Sun makes a full rotation once every 25 – 35 days.
Earth is the only planet not named after a God.
"Due to the Sun and Moon’s gravitational pull, we have tides."
Pluto is smaller than the United States.
"According to mathematics, white holes are possible, although as of yet we have found none."
There are more volcanoes on Venus than any other planet in our solar system.
Uranus’ blue glow is due to the gases in its atmosphere.
"In our solar system that are 4 planets known as gas giants: Jupiter, Saturn, Uranus & Neptune."
Uranus has 27 moons that have been discovered so far.
"Because of its unique tilt, a season on Uranus is equivalent to 21 Earth years."
"Neptune’s moon, Triton, orbits the planet backwards."
Triton is gradually getting closer to the planet it orbits.
There are more stars in space than there are grains of sand in the world.
Neptune takes nearly 165 Earth years to make one orbit of the Sun.
"Pluto’s largest moon, Charon, is half the size of Pluto."
The International Space Station is the largest manned object ever sent into space.
A day on Pluto is lasts for 153.6 hours long.
Saturn is the second largest planet in our solar system.
Any free-moving liquid in outer space will form itself into a sphere.
"Mercury, Venus, Earth & Mars are known as the “Inner Planets”."
We know more about Mars and our Moon than we do about our oceans.
The Black Arrow is the only British satellite to be launched using a British rocket.
Only 5% of the universe is visible from Earth.
Light travels from the Sun to the Earth in less than 10 minutes.
"At any given moment, there are at least 2,000 thunderstorms happening on Earth."
The Earth’s rotation is slowing slightly as time goes on.
"If you were driving at 75 miles per hour, it would take 258 days to drive around Saturn’s rings."
Outer Space is only 62 miles away.
The International Space Station circles Earth every 92 minutes.
Stars twinkle because of the way light is disrupted as it passes through Earth’s atmosphere.
"We always see the same side of the Moon, no matter where we stand on Earth."
"There are three main types of galaxies: elliptical, spiral & irregular."
There are approximately 100 thousand million stars in the Milky Way.
"Using the naked eye, you can see 3 – 7 different galaxies from Earth."
"In 2016, scientists detected a radio signal from a source 5 billion light-years away."
The closest galaxy to us is the Andromeda Galaxy – it’s estimated at 2.5 million light-years away.
The first Supernovae observed outside of our own galaxy was in 1885.
The first-ever black hole photographed is 3 million times the size of Earth.
The distance between the Sun & Earth is defined as an Astronomical Unit.
The second man on the moon was Buzz Aldrin. “Moon” was Aldrin’s mother’s maiden name.
Buzz Aldrin’s birth name was Edwin Eugene Aldrin Jr.
"On Venus, it snows metal and rains sulfuric acid."
The Mariner 10 was the first spacecraft that visited Mercury in 1974.
Space is completely silent.
Coca-Cola was the first commercial soft drink that was ever consumed in space.
Astronauts can grow approximately two inches (5 cm) in height when in space.
The Kuiper Belt is a region of the Solar System beyond the orbit of Neptune.
The first woman in space was a Russian called Valentina Tereshkova.
"If Saturn’s rings were 3 feet long, they would be 10,000 times thinner than a razor blade."
The Hubble Space Telescope is one of the most productive scientific instruments ever built.
The first artificial satellite in space was called “Sputnik”.
Exoplanets are planets that orbit around other stars.
The center of the Milky Way smells like rum & tastes like raspberries.
Our moon is moving away from Earth at a rate of 1.6 inch (4 cm) per year!
"Pluto is named after the Roman god of the underworld, not the Disney Dog."
"Spacesuit helmets have a Velcro patch, to help astronauts itch."
The ISS is visible to more than 90% of the Earth’s population.
Saturn is the only planet that could float in water.
"Asteroids are the byproducts of formations in the solar system, more than 4 billion years ago."
Astronauts can’t burp in space.
Uranus was originally called “George’s Star”.
A sunset on Mars is blue.
The Earth weighs about 81 times more than the Moon.
The first living mammal to go into space was a dog named “Laika” from Russia.
The word “astronaut” means “star sailor” in its origins.
“NASA” stands for National Aeronautics and Space Administration.
Gennady Padalka has spent more time in space than anyone else.
"Mercury has no atmosphere, which means there is no wind or weather."
"In China, the Milky Way is known as the “Silver River”."
Red Dwarf stars that are low in mass can burn continually for up to 10 trillion years!
Scientists once believed that the same side of Mercury always faced the Sun.
Jupiter’s Red Spot is shrinking.
A large percentage of asteroids are pulled in by Jupiter’s gravity.
A day on Mercury is equivalent to 58 Earth days.
"As space has no gravity, pens won’t work."
On average it takes the light only 1.3 seconds to travel from the Moon to Earth.
There are 88 recognized star constellations in our night sky.
The center of a comet is called a “nucleus”.
As early as 240BC the Chinese began to document the appearance of Halley’s Comet.
"In 2006, the International Astronomical Union reclassified Pluto as a dwarf planet."
There are 5 Dwarf Planets recognized in our Solar System.
Mars is the most likely planet in our solar system to be hospitable to life.
"Halley’s Comet will pass over Earth again on July 26, 2061."
There is a planet half the radius of the Earth with a surface made up of diamonds.
Buzz Lightyear from Toy Story has actually been to outer space!`;

export default facts;